

































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { IBrandGateway, IGateway } from "@/models/gateways";
import CurrenciesStore from "@/mixins/constants/currenciesStore";
import { ICurrency } from "@/models/constants";
import {
  PaymentMethodType,
  SelectedPaymentManualPayment
} from "@/models/selectPaymentMethod";
import { DataModules } from "@/store/modules/data";
import { mapState } from "vuex";
import { IBrand } from "@/models/brands";
import { UUID } from "@/data/enums";

@Component({
  computed: {
    ...mapState({
      brandGateways(state, getters) {
        return getters[`data/listArray`]({
          storeModule: this.dataModule
        });
      }
    })
  }
})
export default class ManualPayment extends Mixins(CurrenciesStore) {
  @Prop({ required: true })
  public currencyId!: ICurrency["id"];

  @Prop({ default: 0 })
  public totalAmount!: number;

  @Prop({ default: true })
  public showAmountInput!: boolean;

  @Prop({ default: false })
  public canChangeAmount!: boolean;

  @Prop({ default: UUID.ORG })
  public brandId!: IBrand["id"];

  @Prop({ default: false })
  public isDisabled!: boolean;

  public form = {
    gateway_id: "",
    amount: 0,
    transaction_id: ""
  } as {
    gateway_id: IGateway["id"];
    amount: number;
    transaction_id?: string;
  };
  // Getters
  public brandGateways!: IBrandGateway[];
  // Data
  public dataModule = DataModules.BRAND_GATEWAYS;
  public isLoading = true;
  public requestError = false;
  public isReloading = false;

  public async created() {
    this.form.amount = this.totalAmount;
    await this.getBrandGateways();
  }

  public setForm() {
    this.form.gateway_id = this.$_.get(
      this.brandGatewaysSorted,
      "0.gateway_id"
    );
    this.form.amount = this.totalAmount;
  }

  public reloadBrandGateways() {
    this.isReloading = true;
    this.getBrandGateways();
  }

  public async getBrandGateways() {
    try {
      await this.$store.dispatch(`data/${this.dataModule}/list`, {
        brandId: this.brandId,
        ignoreStored: this.isReloading,
        params: {
          limit: 0,
          order: "order",
          "filter[active]": 1,
          with: "gateway.gateway_provider,gateway.card_types",
          ...this.currencyFilter
        }
      });
      this.setForm();
      this.requestError = false;
    } catch (error) {
      this.requestError = true;
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public get currencyFilter() {
    return this.currencyId
      ? {
          "filter[gateway.currencies.id]": this.currencyId
        }
      : {};
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: this.dataModule,
      vm: this
    });
  }

  public get currency(): ICurrency {
    return this.$_.find(this.currencies, ["id", this.currencyId]) as ICurrency;
  }

  public get brandGatewaysSorted() {
    return this.$_.sortBy(this.brandGateways, "gateway.name");
  }

  @Watch("currenciesLoaded")
  public currenciesLoadedWatcher() {
    this.formChanged();
  }

  @Watch("totalAmount")
  public onTotalAmountChange() {
    this.form.amount = this.totalAmount;
  }

  @Watch("form", { deep: true })
  public formChanged() {
    const data = this.$_.clone(this.form);
    if (this.$_.isEmpty(data.transaction_id)) {
      delete data.transaction_id;
    }
    this.$emit("input", {
      type: PaymentMethodType.MANUAL_PAYMENT,
      data
    } as SelectedPaymentManualPayment);
  }
}
